// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1_82u","label":"SetPasswdForm_label__1s1VD"};